import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'


import { OperadorModel } from './operador.model'

import { ExibirMenuService } from '../shared/exibir-menu.service'
import { NotificationsService } from 'angular2-notifications'
import { DadosAcessoService } from '../../dadosAcesso.service'
import { AcessoApiService } from '../../acessoApi.service'
import { TextMaskModule } from 'angular2-text-mask';
import { text } from '@angular/core/src/render3/instructions';


declare var $: any;

@Component({
  selector: 'app-cad-oper',
  templateUrl: './cad-oper.component.html',
  styleUrls: ['./cad-oper.component.css']
})
export class CadOperComponent implements OnInit {
  public id_pessoa: string = ""
  public id_oper: string = ""
  public codOper: string = ""
  public cpf: string = "";
  public senha: string = "";
  public confimarSenha: string = "";
  public nome: string = "";
  public nomeLoja:  string = "";
  public fantasia: string = "";
  public email: string = "";
  public dataNascimento: Date;
  public Operador: any
  public data: string
  public dataConvertidaAmericano: string
  public objetoOperador: OperadorModel[]

  public trava: boolean = true
  public desabilitaBtn: boolean
  public textoBotao: string = "Enviar Dados"

  public cod_loja: string

  public options = {
    position: ["bottom", "right"],
    timeOut: 5000,
    lastOnBottom: true
  }
  public maskCpf = [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/ ]
  public datamask = [/[0-9]/, /\d/, '/', /\d/, /\d/,'/', /\d/, /\d/, /\d/, /\d/ ]


  constructor(public exibir: ExibirMenuService, private acessoAPI: AcessoApiService, public notificacao: NotificationsService, private dadosAcesso: DadosAcessoService, private router: Router) {
    if(sessionStorage.getItem('cod_loja') === null){

      this.router.navigate(["/"])
    }
    this.cod_loja = sessionStorage.getItem('cod_loja');
    this.acessoAPI.getCodOperExistente(this.cod_loja).subscribe(res => {

      this.cod_loja = res[0].cod_loja
      this.nomeLoja = res[0].nome_loja
      this.codOper = res[0].cod_oper
      this.cpf = res[0].cpf
      this.nome = res[0].nome_oper
      this.fantasia = res[0].fantasia_nome
      this.email = res[0].email
      this.dataNascimento = res[0].dtNascimento
      this.Operador = res

      if(this.codOper === null){
        this.trava = false
        this.desabilitaBtn = true
      }else{
        this.trava = true
        this.desabilitaBtn = false
      }
    });

    this.exibir.setItensVisiveis(true);

  }

  ngOnInit() {

  }



  validarSenha(){
    var senha = $("#SENHA").val()
    var confirSenha = $("#SENHA_CONF").val()

    if(senha === confirSenha){
      this.notificacao.success(
        'Verificado!',
        'Senhas compatíveis!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      )
      $("#SENHA").css("border-color","green")
      $("#SENHA_CONF").css("border-color","green")

    }else{
      this.notificacao.error(
        'Senhas Erradas!',
        'Digite a mesma senha para continuar!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      )

      $("#SENHA").css("border-color","red")
      $("#SENHA_CONF").css("border-color","red")

    }
  }

  recuperarPessoa(){
    var cpf = $("#CPF_OPER").val();
    this.acessoAPI.getOperadorPorDocumento(cpf, this.cod_loja).subscribe(data =>{
      this.notificacao.success(
        'Pessoa localizada',
        'Encontramos uma pessoa com o CPF informado,' +
        'iremos carregar os dados desta Pessoa, Aguarde um momento...',
        {
          timeOut: 4000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }),
      this.id_pessoa = data[0].id_pessoa;
      this.id_oper = data[0].id_oper;
      this.codOper = data[0].cod_oper;
      this.cod_loja = data[0].cod_loja;
      this.nomeLoja = data[0].nome_loja;
      this.codOper = data[0].cod_oper;
      this.cpf = data[0].cpf;
      this.nome = data[0].nome_oper;
      this.fantasia = data[0].fantasia_nome;
      this.email = data[0].email;
      this.dataNascimento = data[0].dtNascimento.toString()
      this.Operador = data;

      if (this.id_pessoa != null) {
          sessionStorage.setItem('id_pessoa', this.id_pessoa)
          this.trava = false;
      }
      if (this.id_oper != null) {
          sessionStorage.setItem('id_pessoa', this.id_oper)
          this.trava = true;
      }

    }, error => {
        this.notificacao.info(
          'Não posui operador com o CPF informado!',
          '',
          {
            timeOut: 4000,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: false,
            maxLength: 2
          }
        );
      }
    );
  }

  ValidarCPF() {
    const cpf = $('#CPF_OPER').val();

    this.acessoAPI.validaCPF(cpf).subscribe(data => {
      this.notificacao.success(
        'Verificado!',
        'CPF é válido!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      );
      this.recuperarPessoa();

      $('#CPF_OPER').css('border-color', 'green');

    }, error => {
      this.notificacao.error(
        'Erro CPF!',
        'Digite um CPF válido!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      );
      $('#CPF_OPER').css('border-color', 'red');
    }
  );
}

  validarDados(): void {
    var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    var NomeVal = /[A-z][ ][A-z]/;

    this.codOper = $('#COD_OPER').val();
    this.cpf = $('#CPF_OPER').val();
    this.senha = $('#SENHA').val();
    this.confimarSenha = $('#SENHA_CONF').val();
    this.nome = $('#NOME_PESSOA').val();
    this.fantasia = $('#FANTASIA_PESSOA').val();
    this.email = $('#ENDERECO_EMAIL').val();
    this.dataNascimento = $('#NASCIMENTO_PESSOA').val();
    this.data = this.dataNascimento.toString();
    var dataQuebrada = this.data.split('/');
    var hoje = new Date();
    var ano = hoje.getFullYear();
    var anoConver = ano.toString();
    this.dataConvertidaAmericano = dataQuebrada[1] + '/' + dataQuebrada[0] + '/' + dataQuebrada[2];
    if (this.codOper === '') {
      this.notificacao.error(
        'Campo em Branco!',
        'Digite seu código de operador para continuar!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      );
    } else if (this.cpf === '') {
      this.notificacao.error(
        'Campo em Branco!',
        'Digite seu CPF para continuar!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      );
    } else if (parseInt(dataQuebrada[0]) > 31 || parseInt(dataQuebrada[1]) > 12 || parseInt(dataQuebrada[2]) < 1920 || parseInt(dataQuebrada[2]) > parseInt(anoConver) - 10 ) {
      this.notificacao.error(
        'Data Inválida!',
        'Digite uma data válida para continuar!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      );
    } else if (this.senha !== this.confimarSenha) {
      this.notificacao.error(
        'Senhas diferentes!',
        'Digite a mesma senha para continuar!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      );
    } else if (this.senha === '' && this.id_oper === '') {
      this.notificacao.error(
        'Campo em Branco!',
        'Digite sua Senha para continuar!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      );
    } else if (this.confimarSenha === '' && this.id_oper === '') {
      this.notificacao.error(
        'Campo em Branco!',
        'Confirme sua senha para continuar!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      );
    } else if (this.nome === '') {
      this.notificacao.error(
        'Campo em Branco!',
        'Digite o Nome para continuar!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      );
    } /*else if (!NomeVal.test(this.nome)) {
      this.notificacao.error(
        'Nome Inválido!',
        'Digite o Nome Completo para continuar!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      )
    }*/
     else if (this.fantasia === '') {
      this.notificacao.error(
        'Campo em branco!',
        'Digite a fantasia para continuar!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      );
    } else if (this.email === '') {
      this.notificacao.error(
        'Campo em branco!',
        'Digite o email para continuar!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      );
    } else if (!filter.test(this.email)) {
      this.notificacao.error(
        'E-mail inválido!',
        'Digite o email válido para continuar!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      );
    } else if (this.dataNascimento === undefined || this.dataNascimento.toString() === '') {
      this.notificacao.error(
        'Campo em branco!',
        'Digite a Data de nascimento para continuar!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      );
    } else {

      const codig_loja = sessionStorage.getItem('cod_loja');
      const nome_loja = sessionStorage.getItem('nome_loja');

      this.textoBotao = 'Aguarde...';
      $('#EnviarBtn').prop('disabled', true);

      this.acessoAPI.EnviaCadastroOperador(this.id_pessoa, this.id_oper, codig_loja, nome_loja, this.codOper, this.cpf,
        this.nome, this.fantasia, this.email, this.dataConvertidaAmericano, this.senha, this.confimarSenha).subscribe(data => {
          this.notificacao.success(
            'Sucesso!',
            'Dados Enviados!',
            {
              timeOut: 2000,
              showProgressBar: false,
              pauseOnHover: false,
              clickToClose: false,
              maxLength: 2
            }
          );
          this.trava = true;
          this.desabilitaBtn = false;
          this.textoBotao = 'Enviar Dados';
         }, error => {
          this.notificacao.error(
            'Erro!',
            error._body.replace(/["]/g, ''),
            {
              timeOut: 5000,
              showProgressBar: false,
              pauseOnHover: false,
              clickToClose: false,
              maxLength: 2
            }
          );
          this.desabilitaBtn = true;
          this.textoBotao = 'Enviar Dados';
          $('#EnviarBtn').prop('disabled', false);
        }
      );
    }
  }
}






// WEBPACK FOOTER //
// ./src/app/pages/cad-oper/cad-oper.component.ts